<template>
  <div>

    <!-- Navigation -->
    <navigation-bar></navigation-bar>

    <!-- Hauptinhalt -->
    <div class="container-fluid mt-4">
      <!-- Linker Bereich: Auftrag Details -->
      <div class="row">
        <div class="col-md-3 order-details text-left email-table-wrapper">
          <h4>Megrendelés adatok</h4>
          <ul v-if="megrendeles">
            <li><span>Megrendelő:</span> <strong>{{ megrendeles.megrendelo }}</strong></li>
            <li><span>Felrakó:</span> <strong>{{ megrendeles.felrako }}</strong></li>
            <li><span>Felrakó hely:</span> <strong>{{ megrendeles.fhely }}</strong></li>

           <!-- Zusätzliche Felrako-Daten (tipus=1) -->
            <li v-for="extra in extraFields.filter(item => item.tipus === '1')" :key="extra.az">
              <span>Tov.felrakó:</span>
              <strong>{{ extra.sorrend }} - {{ extra.tav_megn }} - {{ extra.ceg }}</strong>
            </li>


            <li><span>Lerakó:</span> <strong>{{ megrendeles.lerako }}</strong></li>
            <li><span>Lerakó hely:</span> <strong>{{ megrendeles.lhely }}</strong></li>
            

          <!-- Zusätzliche Lerako-Daten (tipus=2) -->
          <li v-for="extra in extraFields.filter(item => item.tipus === '2')" :key="extra.az">
              <span>Tov.lerakó:</span>
              <strong>{{ extra.sorrend }} - {{ extra.tav_megn }} - {{ extra.ceg }}</strong>
            </li>


            <li><span>Cikk:</span> <strong>{{ megrendeles.cikk }}</strong></li>
            
            <li><span>Dátum:</span> <strong>{{ megrendeles.m_datumtol }}</strong></li>
            <li><span>Szállítási határidő:</span> <strong>{{ megrendeles.szall_hatarido }}</strong></li>

            
            <li><span>Súly:</span> <strong>{{ megrendeles.m_suly }}</strong></li>
            <li>
              <span>KM:</span>
              <strong>{{ megrendeles.m_km }}</strong>
              <small v-if="megrendeles?.pontvonal_hossz != null" class="text-muted">
                (Terv út hossza: <b>{{ formatKm(megrendeles.pontvonal_hossz) }}</b> km)
              </small>
            </li>
            
           <li>
              <span>Hivatkozási szám:</span>
              <strong>{{ megrendeles.hivatkozasi_szam }}</strong>
            </li>

            <li v-if="megrendeles.loading_ref">
              <span>Loading ref.:</span>
              <strong>{{ megrendeles.loading_ref }}</strong>
            </li>

            <li v-if="showNtFields">
              <span>NT köteg:</span>
              <strong>{{ megrendeles.nt_koteg || '-' }}</strong>
            </li>

            <li v-if="showNtFields">
              <span>NT érvényes:</span>
              <strong>{{ megrendeles.nt_ervenyes || '-' }}</strong>
            </li>

            <li>
              <span>GMP: </span>
              <input type="checkbox" disabled v-model="gmpCheckbox">
              <span v-if="gmpCheckbox"> igen</span>
              <span v-else> nem</span>
            </li>

              
            <li><span>Megrendelői ár:</span> <strong>{{ megrendeles.m_aregysegar }}</strong></li>
            <li><span>Ártípus:</span> <strong>{{ megrendeles.m_egysegarme }}</strong></li>

            <li><span>Alapért.alv díj:</span> <strong>{{ megrendeles.mar_egysegar }}</strong></li>
            <li><span>Alv ártipus:</span> <strong>{{ megrendeles.mar_egysegarme }}</strong></li>
            
            <li><span>Megjegyzés:</span> <strong>{{ megrendeles.megjegyzes }}</strong></li>
            
            <li><span>Fuvarszervező:</span> <strong>{{ megrendeles.fuvarszervezo }}</strong></li>
            <li><span>Készítette:</span> <strong>{{ megrendeles.felh }}  ({{megrendeles.made  }})</strong></li>
            <li><span>Utolsó módosítás:</span> <strong>{{ megrendeles.mod_felh }}  ({{ megrendeles.timest }})</strong></li>
            <li><span>Csoport:</span> <strong>{{ megrendeles.csoport }}</strong></li>
            <li><span>FTR AZ:</span> <strong>{{ megrendeles.az }}</strong></li>
            <li><span>VIR AZ:</span> <strong>{{ megrendeles.m_az }}</strong></li>
            <li><span>Belső hivatkozási szám:</span> <strong>{{ megrendeles.belsoHivatkozas }}</strong></li>
            
          </ul>
          <p v-else>Adattöltés folyamatban...</p> <!-- Anzeige eines Ladezustands -->
        </div>

        <!-- Rechter Bereich: Buttons für Aktionen -->
        <div class="col-md-2 action-buttons">

          <button 
            class="btn btn-lg btn-vissza mb-2" 
            @click="goBack"
          >
            ← Vissza
          </button>


          <button 
           v-if="isFuvarszervezoOrAdmin"
          class="btn btn-primary btn-block mb-2" @click="editOrder">Megrendelés szerkesztése</button>
             <!-- Megrendelés kész Button (Deaktiviert) -->
              <button 
                class="btn btn-success btn-block mb-2" 
                @click="markAsComplete" 
                :disabled="true"
              >
              Megrendelés kész
            </button>

            <button class="btn btn-info btn-block mb-2" @click="toggleDateField">Dátum módosítása</button>
            <button class="btn btn-warning btn-block mb-2" @click="toggleCopyField">Megrendelés másolása</button>

            <!-- Megrendelés törlése Button () -->
            <button 
              class="btn btn-danger btn-block mb-2" 
              @click="confirmDeleteOrder" >
              Megrendelés törlése
            </button>

            <!-- Eingabefeld für Datum -->
            <div v-if="showDateField" class="mt-3">
              <label for="newDate">Új dátum:</label>
              <input 
                id="newDate" 
                type="date" 
                v-model="newDate" 
                class="form-control mb-2" 
              />
              <button class="btn btn-primary btn-block" @click="startDateUpdate">Start</button>
            </div>

            <!-- Eingabefeld für Megrendelés másolása -->
            <div v-if="showCopyField" class="mt-3">
                <label for="copyDate">Új dátum:</label>
                <input 
                  id="copyDate" 
                  type="date" 
                  v-model="copyDate" 
                  class="form-control mb-2" 
                />
                <label for="copyWeight">Új mennyiség:</label>
              <input 
                id="copyWeight" 
                type="number" 
                v-model="m_suly_new" 
                class="form-control mb-2" 
              />
                <label for="copyRef">Új belső hivatkozás:</label>
                <input 
                  id="copyRef" 
                  type="text" 
                  v-model="belsoHivatkozas_new" 
                  class="form-control mb-2" 
                />
              <button class="btn btn-primary btn-block" @click="startCopyOrder">Start</button>
            </div>

          <!-- Neuer Button -->
          <button 
            class="btn btn-secondary btn-block mb-2" 
            @click="navigateToOrderList"
          >
            Hivatkozási szám áttekintése
          </button>
        
          <button
              class="btn btn-tobb-felrako btn-block mb-2"
              @click="editExtra">Több felrakó - lerakó
            </button>
          
         <button
            class="btn btn-outline-dark btn-block mb-2"
            @click="openUtvonalModal"
          >
            Útvonal térkép
          </button>

          <small class="text-muted d-block mb-2">
            Útvonal: <b>{{ megrendeles && megrendeles.polyline ? 'térkép hozzárendelve.' : 'NULL' }}</b>
          </small>
            


        
        </div>






        <!-- Rechte Spalte: E-Mails -->
        <div class="col-md-7 ">
          <!-- Zugeordnete E-Mails -->
          <div class="emails-section mb-4">
            <h5>Csatolt email</h5>
            <div class="table-responsive smaller-table email-table-wrapper">
              <table class="table">
                <thead>
                  <tr>
                    <th>Dátum</th>
                    <th>Küldő</th>
                    <th>Tárgy</th>
                    
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="email in assignedEmails" :key="email.id" @click="openEmailModal(email)">
                    <td>{{ email.receivedDateTime }}</td>
                    <td>{{ email.from_name }} ({{ email.from_email }})</td>
                    <td>{{ email.subject }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Kunden-E-Mails -->
          <div class="emails-section">
            <h5>Email lista</h5>

            <!--   Suchfeld-->
              <div class="d-flex align-items-center mb-3 gap-2">
              <input
                v-model="emailSearch"
                type="text"
                class="form-control form-control-sm email-search-input"
                placeholder="E-mail keresés..."
              />

              <button
                class="btn btn-primary btn-sm d-flex align-items-center justify-content-center"
                :disabled="isLoadingEmails"
                @click="fetchCustomerEmails"
              >
                <span v-if="isLoadingEmails" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                Frissít
              </button>

              <span class="ml-2 text-muted" v-if="!isLoadingEmails && emailSearch">{{ emailCount }} találat</span>


            </div>

         


            <!--  Tabelle -->
            <div class="table-responsive larger-table email-table-wrapper">
              <table class="table email-table">
                <thead>
                  <tr>
                    <th>Dátum</th>
                    <th>Küldő</th>
                    <th>Tárgy</th>
                    <th>Csatolás</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="email in customerEmails" :key="email.id" @click="openEmailModal(email)">
                    <td>{{ email.receivedDateTime }}</td>
                    <td>{{ email.from_name }} ({{ email.from_email }})</td>
                    <td>{{ email.subject }}</td>
                    <td>
                      <button class="btn btn-sm btn-success"  @click.stop="assignEmailToOrder(email.az)">
                        <i class="fa fa-link"></i> 
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            
               <!-- Modal: Útvonal térkép -->
          <div v-if="showUtvonalModal" class="utvonal-modal">
            <div class="utvonal-modal-content">
              <button class="close-button-inside" @click="closeUtvonalModal">&times;</button>

              <h5 class="mb-2">
                Útvonal térkép
                <small v-if="megrendeles?.pontvonal_hossz != null" class="text-muted">
                  — Terv út hossza: <b>{{ formatKm(megrendeles.pontvonal_hossz) }}</b> km
                </small>
              </h5>

              <div id="utvonal-modal-map" style="height: 70vh; width: 100%;"></div>

             
            </div>
          </div>
            
            
            
            </div>
          </div>
        </div>
      

            <!-- Modal für die E-Mail-Anzeige -->
            <div v-if="showEmailModal" class="email-modal">
              <div class="email-modal-content">
                <!-- X Button innerhalb des Fensters -->
                <button class="close-button-inside" @click="closeEmailModal">
                  &times;
                </button>
                <h5>Tárgy: {{ selectedEmail.subject }}</h5>
                <p><strong>Küldő:</strong> {{ selectedEmail.from_name }} ({{ selectedEmail.from_email }})</p>
                <p><strong>Címzett:</strong> {{ selectedEmail.to_email }}</p>
                <p><strong>CC:</strong> {{ selectedEmail.cc_email }}</p>
                <p><strong>Dátum:</strong> {{ selectedEmail.receivedDateTime }}</p>
                <hr />
                <div v-html="selectedEmail.bodyHtml || selectedEmail.bodyPlainText"></div>
              </div>
            </div>


       




      
      </div>
    </div>
  </div>
</template>

<script>
import axiosInstance from '@/axiosInstance';
import { mapGetters } from 'vuex';
import { mapMutations } from 'vuex';
import axiosInstanceV3 from '@/axiosInstanceV3';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

export default {
  data() {
    return {
      megrendeles: null,
      extraFields: [], // Több fel-lerako

      showEmailModal: false,
      selectedEmail: {}, // Die aktuell ausgewählte E-Mail

      assignedEmails: [], // E-Mails, die der Order zugeordnet sind
      customerEmails: [], // E-Mails, die zum Kunden gehören
      emailsWithModal: [], // E-Mails mit Modal-Status

      showDateField: false, // Steuerung für Datumfeld
      showCopyField: false, // Für Megrendelés másolása
      newDate: '',          // Neues Datum
      copyDate: '',          // Datum für Megrendelés másolása
      m_suly_new: 0, // Neues Feld für das Gewicht
      belsoHivatkozas_new: '',  // neues Feld

        searchText: '',
    
        errorMessage: '',
        emailSearch: '', // ← initial leerer Suchbegriff
        isLoadingEmails: false, // ← NEU
        emailCount: 0,
          showUtvonalModal: false,
        utvonalMap: null,

    };
  },


  computed: {
    ...mapGetters(['getorderData']),
    ...mapGetters(["getUserData"]),

        isFuvarszervezoOrAdmin() {
        const tipus = this.getUserData?.tipus;
        return tipus === 'admin' || tipus === 'fuvarszervező';
      },
        az() {
          return this.getorderData?.az || null;
        },
        napifo_az() {
          return this.getorderData?.napifo_az || null;
        },
        
        gmpCheckbox() {
          console.log('gmp',this.megrendeles.gmp);
        return this.megrendeles?.gmp == -1;  // true für Ja (-1), false für Nein (0)
      }, 
      fsz() {
            return this.getUserData ? this.getUserData.fsz : null;
          }, 
    hasUtvonalPolyline() {
        return !!(this.megrendeles && this.megrendeles.polyline);
      },

      showNtFields() {
        const megrendelo = String(
          this.megrendeles?.megrendelo || ''
        ).toUpperCase();

        return megrendelo.includes('NT') ||
          !!this.megrendeles?.nt_koteg ||
          !!this.megrendeles?.nt_ervenyes;
      },

  },
 


  async mounted() {
    this.fetchOrderDetails();
    this.updateLogParams();
   // this.fetchEmailsByOrder();
    
  },
  methods: {
    ...mapMutations(['setLogParams']),
  

formatKm(v) {
  const n = Number(v);
  if (!isFinite(n)) return v;
  return n.toFixed(3);
},

openUtvonalModal() {
  if (!this.hasUtvonalPolyline) return;
  this.showUtvonalModal = true;

  this.$nextTick(() => {
    this.initUtvonalMap();
  });
},

closeUtvonalModal() {
  this.showUtvonalModal = false;

  if (this.utvonalMap) {
    this.utvonalMap.remove();
    this.utvonalMap = null;
  }
},

initUtvonalMap() {
  const encoded = this.megrendeles?.polyline;
  if (!encoded) return;

  // wenn Modal erneut geöffnet wird
  if (this.utvonalMap) {
    this.utvonalMap.remove();
    this.utvonalMap = null;
  }

  const coords = this.decodePolyline(encoded, 5);
  if (!coords.length) return;

  const latLngs = coords.map(([lat, lng]) => [lat, lng]);

  this.utvonalMap = L.map('utvonal-modal-map', { preferCanvas: true });

  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    maxZoom: 19,
    attribution: '&copy; OpenStreetMap contributors'
  }).addTo(this.utvonalMap);

  const line = L.polyline(latLngs, { weight: 4 }).addTo(this.utvonalMap);

  // Start / End (ohne Marker-Icons -> kein Vite/Icon-Fix nötig)
  L.circleMarker(latLngs[0], { radius: 6 }).addTo(this.utvonalMap).bindPopup('Start');
  L.circleMarker(latLngs[latLngs.length - 1], { radius: 6 }).addTo(this.utvonalMap).bindPopup('Cél');

  this.utvonalMap.fitBounds(line.getBounds(), { padding: [20, 20] });

  // wichtig, falls Modal/Container "hidden -> visible"
  setTimeout(() => this.utvonalMap && this.utvonalMap.invalidateSize(), 0);
},

// --- Polyline decode (Google Encoded Polyline Algorithm) ---
decodePolyline(encoded, precision = 5) {
  if (!encoded || typeof encoded !== 'string') return [];

  let index = 0;
  let lat = 0;
  let lng = 0;
  const coordinates = [];
  const factor = Math.pow(10, precision);

  while (index < encoded.length) {
    let result = 0;
    let shift = 0;
    let b;

    do {
      b = encoded.charCodeAt(index++) - 63;
      result |= (b & 0x1f) << shift;
      shift += 5;
    } while (b >= 0x20);

    const deltaLat = (result & 1) ? ~(result >> 1) : (result >> 1);
    lat += deltaLat;

    result = 0;
    shift = 0;

    do {
      b = encoded.charCodeAt(index++) - 63;
      result |= (b & 0x1f) << shift;
      shift += 5;
    } while (b >= 0x20);

    const deltaLng = (result & 1) ? ~(result >> 1) : (result >> 1);
    lng += deltaLng;

    coordinates.push([lat / factor, lng / factor]);
  }

  return coordinates;
},



//************************** */
    
 async fetchCustomerEmails() {

    this.isLoadingEmails = true;

    const cegAz = this.getUserData.ceg_az;
    const vkod = this.megrendeles.m_megrendeloaz;
    const search = this.emailSearch.trim(); // <-- korrektes Feld


    try {
      const url = `/emails.php?ceg_az=${cegAz}&v_kod=${vkod}${search ? `&search=${encodeURIComponent(search)}` : ''}`;

     console.log('Email lekérés URL:', url);
      const response = await axiosInstanceV3.get(url);

      if (response.status === 200) {
        this.customerEmails = response.data;
        this.errorMessage = '';
        this.emailCount = response.data.length;

      } else {
        this.errorMessage = 'Nem sikerült az e-mailek lekérése.';
        this.emailCount =0;

      }
    } catch (error) {
      console.error('Hiba:', error);
      this.errorMessage = 'Szerverhiba történt az e-mailek lekérése közben.';
    } finally {
      this.isLoadingEmails = false; // egal ob Erfolg oder Fehler
  }
  },

  //********************************************************************************************* */

    async assignEmailToOrder(emailId) {//******************************************************************************* */
      const postData = {
        order_az: this.az, // Order ID
        email_az: emailId, // E-Mail ID
        fsz: this.fsz, // User
        ceg_az:  this.getUserData.ceg_az // Unternehmens-ID
      };

      try {

        console.log('assignEmailToOrder',postData);

        const response = await axiosInstance.post('/emails/set_email_order.php', postData);
        
        if (response.status === 200 && response.data && response.data.id > 0) {
        console.log('E-Mail erfolgreich zugeordnet. ID:', response.data.id);
        //alert('E-Mail erfolgreich zugeordnet!');
        // Optional: Aktualisieren Sie die Liste der zugeordneten E-Mails
        this.fetchEmailsByOrder();
      } else {
        console.error('Fehler beim Zuordnen der E-Mail:', response.data);
        alert('Hiba az email hozzárendelésnél, kérem értesítse a programozót. ', postData);
      }
      } catch (error) {
        console.error('Fehler beim Zuordnen der E-Mail:', error);
        alert('Hiba az email hozzárendelésnél, kérem értesítse a programozót. ', postData, error);
      }
    },


    openEmailModal(email) {//******************************************************************************* */
      console.log("Email angeklickt:", email);
      this.selectedEmail = email; // Setzt die ausgewählte E-Mail
      this.showEmailModal = true; // Zeigt das Modal an
    },
    closeEmailModal() {
      this.showEmailModal = false; // Versteckt das Modal
      this.selectedEmail = {}; // Leert die ausgewählte E-Mail
    },

      updateLogParams() {//********************************************************************** */
      const logParams = {
        user: '',  // oder fsz, je nach Logik
        table_name: 'ftr_megrendeles',
        record_id: this.napifo_az
      };
      this.$store.commit('setLogParams', logParams);
    },
    goBack() {//******************************************************************************* */
          this.$router.back(); // Geht zur letzten Seite zurück
        },

    editOrder() {//******************************************************************************* */
      this.$router.push({ name: 'editOrder' });
    },
    editExtra() {//******************************************************************************* */
      this.$router.push({ name: 'ExtraFieldsManager' });
    },
    navigateToOrderList() {//*************************************************************** */
      this.$router.push({ name: 'OrderList' });
    },
    toggleDateField() {//****************************************************************** */
        // Zeige oder verstecke das Datumsfeld
        this.showDateField = !this.showDateField;
      },
        // Umschalten des Datumsfelds für Megrendelés másolása
      toggleCopyField() {//***************************************************************** */
        this.showCopyField = !this.showCopyField;
        this.m_suly_new = this.megrendeles?.m_suly || 0; // Fülle das Feld mit dem aktuellen Gewicht
        this.belsoHivatkozas_new = this.megrendeles?.belsoHivatkozas || '';  // ← HIER
        this.showDateField = false; // Schließt das andere Feld
      },
      async startDateUpdate() {//****  visznylat áthelyezése másik napra ***************************************** */
        if (!this.newDate) {
          alert('Kérlek adj meg egy érvényes dátumot!');
          return;
        }

        // Placeholder für API-Aufruf

        const datawert={
          m_datumtol:this.newDate
        };

        const postData = {
          az: this.megrendeles.az,
          data: datawert
        };

        try {

          console.log('athelyezes',postData);
          const response = await axiosInstance.post('/megrendeles/api_update_megrendeles.php', postData);

          if (response.status === 200 && response.data.success) {
            //alert('Megrendelés áthelyezése kész.');
            //this.fetchOrderDetails(); // Daten erneut laden
            //this.showDateField = false; // Feld ausblenden

            this.$store.commit('setNapiDatum', this.newDate);
            // Leite zur Seite "osszesMegrendeles" weiter
            //this.$router.push({ name: 'osszesMegrendeles'});
            this.$router.go(-1);

          } else {
            alert('Fehler beim Aktualisieren des Datums.');
          }
        } catch (error) {
          console.error('Fehler beim Aktualisieren des Datums:', error);
          alert('Hiba történt a módosításnál.');
        }
      },

    async startCopyOrder() {//****************************************************************************** */
      if (!this.copyDate) {
        alert("Kérjük, adjon meg egy dátumot a másoláshoz!");
        return;
      }

      const postData = {
        az: this.megrendeles.az,
        datum_new: this.copyDate,
        m_suly_new: this.m_suly_new, // Übergebe das neue Gewicht
        belsoHivatkozas_new: this.belsoHivatkozas_new

      };

      try {

        console.log('masol postData',postData);

        const response = await axiosInstance.post("/megrendeles/copy_megrendeles.php", postData);
        if (response.data.success) {
         // alert("Megrendelés másolása sikeres! Új az: " + response.data.id);
          this.$store.commit('setNapiDatum', this.copyDate);
          // Leite zur Seite "osszesMegrendeles" weiter
          //this.$router.push({ name: 'osszesMegrendeles' });
          this.$router.go(-1);

        } else {
          console.error("Hiba történt a másolás során:", response.data.error);
          alert("Hiba történt a másolás során: " + response.data.error);
        }
      } catch (error) {
        console.error("API-hiba:", error);
        alert("Hiba történt a másolás során. Kérjük, próbálja újra.");
      }
    },


    async fetchExtraFields(ftr_megraz) {
      //Több fel-lerako
        const postData = {
          ceg_az: this.getUserData.ceg_az,
          ftr_megrAz: ftr_megraz
      };
      try {

        console.log('több fel-lerako',postData);

        const response = await axiosInstance.post('/fellerakok/list_ftraz.php', postData);
        if (response.status === 200 && response.data.data && response.data.data.length > 0) {
          console.log('extraFields',response.data.data);
          this.extraFields = response.data.data;
        } else {
          console.log('Keine extra Felder gefunden:', response);
        }
      } catch (error) {
        console.error('Fehler beim Abrufen der extra Felder:', error);
      }
    },

    async fetchOrderDetails() {//******************************************************************************** */
      
      const xx=this.napifo_az;
      const postData = {
        az: this.napifo_az
      };
      try {
        console.log('***posData****',postData);
        const url = "/megrendeles/egy_megrendeles.php";
        const response = await axiosInstance.post(url, postData);

        console.log('fetchOrderDetails----', response.data);

        if (response.status === 200 && response.data.data && response.data.data.length > 0) {
          this.megrendeles = response.data.data[0];
          console.log('megrendeles', this.megrendeles);
             // Speichern der Daten im Vuex-Store

           // das war vorher auskommentiert  
         // this.$store.commit('setorderData', this.megrendeles);

          this.fetchEmailsByCustomer();
          this.fetchEmailsByOrder();
          this.$nextTick(() => {
            this.fetchExtraFields(xx);
          });
        } else {
          console.log('Antwort enthält keine Daten oder ist nicht 200:', response);
          this.errorMessage = 'Fehler beim Abrufen der Daten: ' + response.statusText;
        }
      } catch (error) {
        console.error('Fehler beim Abrufen der Daten:', error);
        this.errorMessage = 'Fehler beim Abrufen der Daten: ' + error.message;
      }

      

    },
    
    
    async fetchEmailsByOrder() {//******************************************************************* */
      /*  
      const postData = {
          ceg_az: this.megrendeles?.ceg_az,
          order_az: this.megrendeles?.az
        };
    */

      if (!this.megrendeles || !this.megrendeles.m_megrendeloaz) {
          console.warn('Megrendelés-Daten nicht vollständig geladen.');
          return;
        }

         const postData = {
          ceg_az:  this.getUserData.ceg_az,
          order_az: this.napifo_az
        };

        console.log('postData for fetchEmailsByOrder', postData);

        try {
          
          const url = '/emails/get_emailOrderAZ.php';
          const response = await axiosInstance.post(url, postData);

          console.log('Response fetchEmailsByOrder', response.data);

          if (response.status === 200 && response.data.data && response.data.data.length > 0) {
            this.assignedEmails = response.data.data;
            //console.log('Assigned Emails', this.assignedEmails);
          } else {
            console.log('Keine Daten oder Antwortstatus ist nicht 200:', response);
            this.errorMessage = 'Fehler beim Abrufen der zugeordneten E-Mails: ' + response.statusText;
          }
        } catch (error) {
          console.error('Fehler beim Abrufen der zugeordneten E-Mails:', error);
          this.errorMessage = 'Fehler beim Abrufen der zugeordneten E-Mails: ' + error.message;
        }
      },

      async fetchEmailsByCustomer() {//************************************************************************** */
          
        
        const cegAz = this.getUserData.ceg_az;
        const vkod = this.megrendeles.m_megrendeloaz;

        console.log('E-mailek lekérése - GET', cegAz, vkod);

        try {

          //const response = await axiosInstanceV3.get(`/emails.php?ceg_az=${cegAz}&v_kod=${vkod}`);
          const response = await axiosInstanceV3.get(`/emails.php?ceg_az=${cegAz}&v_kod=${vkod}&search=${encodeURIComponent(this.emailSearch || '')}`);

          


          console.log('Válasz e-mailek lekérésére', response.data);

          if (response.status === 200 && Array.isArray(response.data) && response.data.length > 0) {
            this.customerEmails = response.data;
            console.log('Megrendelőhöz tartozó e-mailek', this.customerEmails);
          } else {
            console.log('Nincs adat vagy a válaszkód nem 200:', response);
            this.errorMessage = 'Hiba történt a megrendelőhöz tartozó e-mailek lekérésekor: ' + response.statusText;
          }
        } catch (error) {
          console.error('Hiba történt a megrendelőhöz tartozó e-mailek lekérésekor:', error);
          this.errorMessage = 'Hiba történt a megrendelőhöz tartozó e-mailek lekérésekor: ' + error.message;
        }
        
        },


      markAsComplete() {//***************************************************************************************** */
        // Logik für das Markieren des Auftrags als abgeschlossen
      },
      modifyQuantity() {
        // Logik für das Ändern der Menge
      },
      modifyDate() {
        // Logik für das Ändern des Datums
      },
      confirmDeleteOrder() {
        if (confirm('Biztosan törölni szeretné ezt a megrendelést?')) {
            this.deleteOrder();
        }
      },
    async deleteOrder() {//****************************************************************************** */
      // Logik für das Löschen des Auftrags
      
      const datawert={
        storno:-1
      };

      const postData = {
        az: this.napifo_az,
        data: datawert
      };

      try {

          console.log('storno',postData);
        const response = await axiosInstance.post('/megrendeles/api_update_megrendeles.php', postData);

        if (response.status === 200 && response.data.success) {
          //alert('Törlés kész ');
          this.$router.push({ name: 'osszesMegrendeles' });
        } else {
          alert('Fehler beim Aktualisieren des Datums.');
        }
      } catch (error) {
        console.error('Fehler beim Aktualisieren des Datums:', error);
        alert('Hiba történt beim Aktualisieren.');
      }


    }
  }

  

};
</script>

<style scoped>

.container {
  margin-top: 20px; /* Wird benutzt, kann bleiben */

}

.order-details ul {
  list-style-type: none;
  padding: 0;
}

.order-details ul li {
  margin-bottom: 5px;
  line-height: 1.2; /* Kann bleiben, da es den Zeilenabstand regelt */
  font-size: 14px;
}

/* Redundant: action-buttons und andere Klassen überschneiden sich */
.action-buttons .btn {
  width: 100%; /* Reduzierte Breite auf 100%, um besser anzupassen */
  padding: 10px;
  font-size: 16px;
}

.action-buttons {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

input[type="checkbox"][disabled] {
  opacity: 0.8; /* Hilft, wenn Checkbox deaktiviert ist */
  border: 1px solid #ccc;
}

#newDate {
  width: 100%;
  padding: 8px;
  font-size: 14px;
  margin-bottom: 10px;
}

/* Entfernen: Diese Positionierung ist nicht mehr relevant */
.back-button {
  display: none; /* Kann entfernt werden, da es keine Anwendung mehr hat */
}

.emails-section {
  margin-bottom: 20px;
  padding-right: 15px; /* Optional */
}

.smaller-table, .larger-table {
  overflow-y: auto;
}

.smaller-table {
  max-height: 300px; /* Spezifisch für kleine Tabellen */
}

.larger-table {
  max-height: 500px; /* Spezifisch für größere Tabellen */

}

.table {
  table-layout: auto;
  width: 100%;
}

.table th,
.table td {
    padding: 4px; /* Abstand innerhalb der Zellen */
    font-size: 12px; /* Textgröße */
    line-height: 1.0; /* Zeilenhöhe */
    text-align: left; /* Linksbündig für Text */
    
}

.email-table th,
.email-table td {
    padding: 4px; /* Gleicher Abstand */
    font-size: 12px; /* Einheitliche Schriftgröße */
    line-height: 1.0; /* Einheitliche Zeilenhöhe */
    text-align: left; /* Gleiche Textausrichtung */
    
}

.email-table-wrapper {
  border: 2px solid #ccc; /* Rahmenfarbe */
  border-radius: 8px; /* Abgerundete Ecken */
  padding: 15px; /* Innenabstand */
  margin-bottom: 20px; /* Abstand zwischen den Tabellen */
  background-color: #f9f9f9; /* Hintergrundfarbe */
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1); /* Schatten für mehr Tiefe */
}

.email-table-wrapper h5 {
  margin-top: 0;
  font-size: 18px;
  font-weight: bold;
  text-align: left; /* Text linksbündig */
  color: #333;
}

.email-table th:nth-child(1),
.email-table td:nth-child(1) {
  width: 15%; /* Dátum */
}

.email-table th:nth-child(2),
.email-table td:nth-child(2) {
  width: 30%; /* Küldő */
}

.email-table th:nth-child(3),
.email-table td:nth-child(3) {
  width: 47%; /* Tárgy */
}

.email-table th:nth-child(4),
.email-table td:nth-child(4) {
  width: 8%; /* Csatolás */
}




/* Spezielle Modal-Anpassungen */
.email-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.email-modal-content {
  position: relative;
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 70%;
  max-height: 80%;
  overflow-y: auto;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  text-align: left;
}

.email-modal-content p {
  margin-bottom: 5px; /* Reduziert den Abstand zwischen Absätzen */
  line-height: 1.2; /* Verringert die Zeilenhöhe */
  font-size: 14px; /* Optional: Schriftgröße anpassen */
}

.email-modal-content h5 {
  margin-bottom: 10px; /* Reduzierter Abstand unter der Überschrift */
  font-size: 16px; /* Optional: Schriftgröße anpassen */
  line-height: 1.2; /* Verringert die Zeilenhöhe */
}

.email-modal-content div {
  line-height: 1.4; /* Reduziert die Zeilenhöhe im Body-Inhalt */
}


/* X-Button */
.close-button-inside {
  background: none;
  border: none;
  font-size: 1.5rem;
  font-weight: bold;
  position: absolute;
  top: 10px;
  right: 15px;
  cursor: pointer;
  color: #333;
}

.close-button-inside:hover {
  color: #ff0000;
}

/* Spezielles Icon */
.assign-icon {
  cursor: pointer;
  font-size: 1.2rem;
  color: green;
  transition: color 0.3s ease;
}

.assign-icon:hover {
  color: rgb(236, 10, 10);
}

/* Vissza-Button */
.btn-vissza {
  background-color: rgb(164, 245, 59);
  color: rgb(10, 10, 10);
  border: none;
}

.btn-vissza:hover {
  background-color: #478;
}


.assign-icon {
    cursor: pointer;
    font-size: 0.8rem; /* Icon-Größe */
    color: green; /* Standardfarbe */
    transition: color 0.3s ease;
}

.assign-icon:hover {
    color: rgb(236, 10, 10); /* Hover-Farbe */
}


.btn-tobb-felrako {
  background-color: #6f42c1; /* Lila Farbton */
  color: #ffffff;            /* Weißer Text */
  font-weight: 500;          /* Leicht fetter Schriftgrad */
  border: none;             /* Kein Rahmen */
  transition: background-color 0.3s ease;
}

.btn-tobb-felrako:hover {
  background-color: #5a379d; /* Etwas dunkler beim Hover */
  color: #ffffff;            /* Weißer Text */
}

.email-search-input {
  max-width: 300px;
}

.utvonal-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1100;
}

.utvonal-modal-content {
  position: relative;
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 80%;
  max-height: 85%;
  overflow-y: auto;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  text-align: left;
}



</style>
